$('document').ready(() => {
    if (document.querySelector('.range-slider__bar')) {
        let rangeSlider = document.querySelector('.range-slider__bar');
        let rangeSliderMin = parseInt(rangeSlider.dataset.min);
        let rangeSliderMax = parseInt(rangeSlider.dataset.max);
        let rangeSliderInputMin = document.querySelector('.range-slider__inputs-item--min');
        let rangeSliderInputMax = document.querySelector('.range-slider__inputs-item--max');
        noUiSlider.create(rangeSlider, {
            start: [rangeSliderMin, rangeSliderMax],
            connect: true,
            range: {
                'min': rangeSliderMin,
                'max': rangeSliderMax
            },
            format: {
                from: function (value) {
                    return parseInt(value);
                },
                to: function (value) {
                    return parseInt(value);
                }
            }
        });
        rangeSlider.noUiSlider.on('update', function (values, handle) {
            let value = values[handle];
            if (handle) {
                rangeSliderInputMax.value = value;
            } else {
                rangeSliderInputMin.value = Math.round(value);
            }
        });
        rangeSliderInputMax.addEventListener('change', function () {
            rangeSlider.noUiSlider.set([null, this.value]);
        });
        rangeSliderInputMin.addEventListener('change', function () {
            rangeSlider.noUiSlider.set([this.value, null]);
        });
    }
})
